module.exports = __webpack_public_path__ + "img/sample_piechart.3290b618.png";